
var id = "MemberContribution";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 133.5 128\" id=\"MemberContribution\">\n<style type=\"text/css\">\n\t#MemberContribution .st0{fill:'';}\n</style>\n<path class=\"st0\" d=\"M105.7,0c8.8,0,16.1,6.9,16.7,15.7V50c0.1,3.1-2.4,5.6-5.5,5.7c-2.9,0-5.3-2.1-5.6-5v-34c0-2.8-2.1-5.2-4.9-5.5\n\tH16.7c-2.8,0-5.2,2.1-5.5,4.9v95.2c0,2.8,2.1,5.2,4.9,5.5h39.6c3.1,0,5.6,2.4,5.6,5.5c0,2.9-2.1,5.3-5,5.6H16.7\n\tc-8.8,0-16.2-6.9-16.7-15.7V16.7C0,7.8,6.9,0.5,15.7,0h1H105.7z M131.6,73.7c2.1,1.8,2.6,4.9,1,7.3l-0.4,0.6l-33.4,38.9\n\tc-1.9,2.2-5.2,2.6-7.6,0.8L69,104.6c-2.5-1.8-3.1-5.3-1.3-7.8c1.7-2.3,4.9-3,7.4-1.5l0.6,0.4l18.1,13.6l30-35\n\tC125.8,71.9,129.3,71.6,131.6,73.7C131.7,73.6,131.7,73.6,131.6,73.7L131.6,73.7z M61.2,66.8c3.1,0,5.6,2.5,5.6,5.6\n\ts-2.5,5.6-5.6,5.6H33.4c-3.1,0-5.6-2.5-5.6-5.6s2.5-5.6,5.6-5.6H61.2z M89,38.9c3.1,0,5.6,2.5,5.6,5.6s-2.5,5.6-5.6,5.6H33.4\n\tc-3.1,0-5.6-2.5-5.6-5.6s2.5-5.6,5.6-5.6H89z\" />\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
